export enum MessagingProvider {
  twilio = 'twilio',
  telnyx = 'telnyx',
  whatsApp = 'whatsApp',
}
